import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
function statusKey(status) {
    switch (status) {
        case 'not-started':
            return 'recovery.verification_layers.status.not_started';
        case 'in-progress':
            return 'recovery.verification_layers.status.in_progress';
        case 'completed':
            return 'recovery.verification_layers.status.completed';
        case 'failed':
            return 'recovery.verification_layers.status.failed';
        case 'accommodation-requested':
            return 'recovery.verification_layers.status.accommodation_requested';
        case 'awaiting-cross-session':
            return 'recovery.verification_layers.status.awaiting_cross_session';
    }
}
export function RecoveryVerificationLayersStep(props) {
    const { t } = useLocale();
    const completedCount = props.layerStates.filter((ls) => ls.status === 'completed').length;
    return (_jsxs("section", { "aria-labelledby": "layers-heading", children: [_jsx("h3", { id: "layers-heading", children: t('recovery.verification_layers.heading') }), _jsx("p", { children: t('recovery.verification_layers.progress_template', {
                    completed: completedCount,
                    total: props.layerStates.length,
                }) }), _jsx("ul", { "aria-label": t('recovery.verification_layers.layers_aria_label'), children: props.layerStates.map((ls) => (_jsxs("li", { children: [_jsx("strong", { children: t(`recovery.verification_layers.layer.${ls.kind}.label`) }), _jsx("p", { children: t(`recovery.verification_layers.layer.${ls.kind}.description`) }), _jsx("p", { children: _jsx("em", { children: t(statusKey(ls.status)) }) }), ls.status === 'not-started' || ls.status === 'failed' ? (_jsx("button", { type: "button", onClick: () => props.onSubmitLayer({
                                layer: ls.kind,
                                // Phase A scaffolding: stub evidence; Phase B integration
                                // collects real evidence per layer kind via dedicated
                                // sub-step components.
                                evidence: { kind: ls.kind, stub: true },
                            }), children: ls.status === 'failed'
                                ? t('recovery.verification_layers.retry')
                                : t('recovery.verification_layers.start') })) : null] }, ls.kind))) }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('recovery.verification_layers.cancel') })] }));
}
//# sourceMappingURL=verification-layers-step.js.map